__turbopack_context__.v({
  "cardCountOption": "UserPageSubscriptions-module-scss-module__kp_p3a__cardCountOption",
  "clicked": "UserPageSubscriptions-module-scss-module__kp_p3a__clicked",
  "countInput": "UserPageSubscriptions-module-scss-module__kp_p3a__countInput",
  "even": "UserPageSubscriptions-module-scss-module__kp_p3a__even",
  "last": "UserPageSubscriptions-module-scss-module__kp_p3a__last",
  "nftSubscriptionsListItem": "UserPageSubscriptions-module-scss-module__kp_p3a__nftSubscriptionsListItem",
  "notSubscribedTag": "UserPageSubscriptions-module-scss-module__kp_p3a__notSubscribedTag",
  "odd": "UserPageSubscriptions-module-scss-module__kp_p3a__odd",
  "radioInput": "UserPageSubscriptions-module-scss-module__kp_p3a__radioInput",
  "sendBtn": "UserPageSubscriptions-module-scss-module__kp_p3a__sendBtn",
  "subscribedTag": "UserPageSubscriptions-module-scss-module__kp_p3a__subscribedTag",
  "subscriptionHistoryEntry": "UserPageSubscriptions-module-scss-module__kp_p3a__subscriptionHistoryEntry",
  "tagContainer": "UserPageSubscriptions-module-scss-module__kp_p3a__tagContainer",
  "topUpHistoryAccordionBody": "UserPageSubscriptions-module-scss-module__kp_p3a__topUpHistoryAccordionBody",
  "topUpHistoryAccordionButton": "UserPageSubscriptions-module-scss-module__kp_p3a__topUpHistoryAccordionButton",
});
